document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.spotlight-swiper');

  sliders.forEach((el) => {
    const autoplay   = el.dataset.autoplay === 'true';
    const delay      = parseInt(el.dataset.autodelay || '5000', 10);
    const speed      = parseInt(el.dataset.speed || '300', 10);
    const pagination = el.dataset.pagination === 'true';
    const navigation = el.dataset.navigation === 'true';
    const loop       = el.dataset.loop === 'true';
    const space      = parseInt(el.dataset.space || '24', 10);
    const centerView = el.dataset.centerView === 'true';

    new Swiper(el, {
      speed,
      loop,
      spaceBetween: space,
      centeredSlides: centerView,
      // When center view ON → hero style
      // When OFF → normal multi-column
      slidesPerView: centerView ? 'auto' : 1.2,
      breakpoints: centerView
        ? {
            0:   { slidesPerView: 1.15, spaceBetween: 12 },
            640: { slidesPerView: 1.6,  spaceBetween: 16 },
            1024:{ slidesPerView: 'auto', spaceBetween: space }
          }
        : {
            0:   { slidesPerView: 1.15, spaceBetween: 12 },
            640: { slidesPerView: 2,    spaceBetween: 16 },
            1024:{ slidesPerView: 3,    spaceBetween: space }
          },
      autoplay: autoplay
        ? { delay, disableOnInteraction: false }
        : false,
      pagination: pagination
        ? {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
          }
        : false,
      navigation: navigation
        ? {
            nextEl: el.parentElement.querySelector('.nav-next'),
            prevEl: el.parentElement.querySelector('.nav-prev')
          }
        : false
    });
  });
});
